import { render, staticRenderFns } from "./AdminTweets.vue?vue&type=template&id=6c456d09&scoped=true&"
import script from "./AdminTweets.vue?vue&type=script&lang=js&"
export * from "./AdminTweets.vue?vue&type=script&lang=js&"
import style0 from "./AdminTweets.vue?vue&type=style&index=0&id=6c456d09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c456d09",
  null
  
)

export default component.exports